import { Result } from '../../../common-models/Result';
import { HttpServiceBase } from '../../../common-services/Http/HttpServiceBase';
import { RequestLensesInput } from './RequestLensesInput';
import { RequestLensesOutput } from './RequestLensesOutput';

export class RequestLensesService extends HttpServiceBase {

  handle = (input: RequestLensesInput): Promise<Result<RequestLensesOutput> | null> => {
    const promise = this.http.post<Result<RequestLensesOutput>, RequestLensesInput>(
      `${this.baseUrlSislogApi}/v2/order/request-lenses`,
      input
    );
    return promise;
  }
}